import styled from "styled-components";
import * as Variable from "../../CSSVariables";

export const BillingOptionsStyle = styled.div`
  &.disabled {
    color: #9e9e9e;
    pointer-events: none;
  }
  > div {
    display: flex;
    border: 1px solid #ccc;
    padding: 8px;

    &:first-child {
      border-radius: 8px 8px 0 0;
    }
    &:last-child {
      border-top: none;
      border-radius: 0 0 8px 8px;
    }
    input[type="radio"],
    label {
      cursor: pointer;
    }
    input[type="radio"] {
      height: 16px;
      width: 16px;
      margin-right: 6px;
    }
    label {
      flex-grow: 100;
    }
  }
  + div {
    margin-top: 12px;
  }
`;